import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiUrlService} from "./api-url.service";


@Injectable({
    providedIn: 'root',
})
export class AnhangDownloadService {

    private readonly http: HttpClient = inject(HttpClient);
    private apiUrlService = inject(ApiUrlService);

    fetchDownload(ordner: string, nachrichtId: string, anhangId: string): Observable<Blob> {
        return this.http.get(`${this.apiUrlService.getApiUrl()}/ordner/${ordner}/nachrichten/${nachrichtId}/anhaenge/${anhangId}`, {
            responseType: 'blob',
        });
    }
}
